const data = [
  {
    title: 'MOST CREATIVE PEOPLE IN BUSINESS',
    description:
      'Leaders who are shaping the future of business in creative ways.',
    logo:
      'https://images.fastcompany.net/image/upload/v1536778764/fcweb/mcpnewlogo_d7dgyh.svg',
    image:
      'https://images.fastcompany.net/image/upload/h_475,f_auto,q_auto,fl_lossy/v1527691238/fcweb/p-3-11-For-changing-the-narrative-FA0618WITH001_bhyidq__1_t7dxl2.jpg',
    link: 'https://www.fastcompany.com/most-creative-people/2018'
  },
  {
    title: 'INNOVATION by design',
    description:
      'The best products, services, interfaces, and design ideas in business.',
    logo:
      'https://images.fastcompany.net/image/upload/v1536781102/fcweb/IBD_small-icon-50x50px-fix_s2op0e.svg',
    image:
      'https://images.fastcompany.net/image/upload/h_475,f_auto,q_auto,fl_lossy/v1513181808/fcweb/p-2-feature-219-Microsoft-rewrites-the-code_ttdxaq.jpg',
    link: 'https://www.fastcompany.com/innovation-by-design/2018'
  },
  {
    title: 'Most Innovative Companies',
    description:
      'The top companies in entertainment, media, sports, technology, and more.',
    logo:
      'https://images.fastcompany.net/image/upload/v1536778764/fcweb/micnewlogo_ctvsdy.svg',
    image:
      'https://images.fastcompany.net/image/upload/h_475,f_auto,q_auto,fl_lossy/v1519143105/fcweb/p-waze-mar-223-FA0318WAZE001_mg0zsj.jpg',
    link: 'https://www.fastcompany.com/most-innovative-companies/2018'
  },
  {
    title: 'World Changing Ideas',
    description:
      'Products, concepts, and policies that are pursuing innovation for good.',
    logo:
      'https://images.fastcompany.net/image/upload/v1536779048/fcweb/wcinewlogo_jebah8.svg',
    image:
      'https://images.fastcompany.net/image/upload/h_475,f_auto,q_auto,fl_lossy/v1523911774/fcweb/p-wci-showing-rescuers-where-theyand8217re-needed-most-FA0518WCIF005_mhbxtp.jpg',
    link:
      'https://www.fastcompany.com/40532898/2018-world-changing-ideas-awards-winners'
  }
];

export default data;
